<div class="container-fluid"  *ngIf="!isDocumento">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a href="#/panel-admin" class="btn btn-primary">
                Volver
              </a>
            </div>
            <h3 class="page-title">Banco de Aspirantes</h3>
        </div>
    </div>
  </div>
  <!-- end page title -->

  <div class="row" style="overflow-x: scroll;">
    <div class="col-12">
      <div class="card" style="border-color: white;">
        <div class="card-body" style="margin-bottom: 150px;">
          <!-- Invoice Logo-->
          <div class="row">
            <div class="col-md-6">
              <label for="estadol" class="col-form-label">Busqueda</label>
              <input
                class="form-control"
                type="text"
                id="buscar"
                placeholder="Buscar estudiante..."
                [(ngModel)]="searchTerm"
                (input)="buscarAccionFormativa()"
              >
            </div>
            <div class="col-md-6">
              <label for="estadol" class="col-form-label">Estado</label>
              <select class="form-select" id="estado" name="estado" (change)="consulta_combos()">
                <option *ngFor="let ed of estado" [value]="ed.id_estado" [selected]="ed.id_estado == sel_edo ? true : false">
                  {{ed.nombre}}
                </option>
              </select>
            </div>

          </div>

          <hr class="text-dark">
          <div class="row">
            <div class="col-12">
              <table class="table">
                <thead>
                  <tr class="table-primary">
                    <th scope="col">N°</th>
                    <th scope="col">Cedula</th>
                    <th scope="col">Nombre(s) y Apellido(s)</th>
                    <th scope="col">Genero</th>
                    <th scope="col">Estados</th>
                    <th scope="col" class="text-center">Planilla Registro</th>
                    <th scope="col" class="text-center">Documentos Cargados</th>
                    <th scope="col" class="text-center">O.C Seleccionadas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let r of filteredResultado; let i = index">
                    <th scope="row">{{i+1}}</th>
                    <td>{{r.identificacion}}</td>
                    <td>{{r.nombre_full}}</td>
                    <td>{{r.genero}}</td>
                    <td>{{r.estado}}</td>
                    <td class="text-center">
                      <a class="btn btn-info text-center puntero" (click)="imprimir(r.id_estudiante, r.identificacion)"><i class="bi bi-file-earmark-break"></i></a>
                    </td>
                    <td class="text-center">
                      <a class="btn btn-primary text-center puntero" (click)="documento(r.id_estudiante, r.nombre_full, r.identificacion)"><i class="bi bi-file-earmark-check"></i></a>
                    </td>
                    <td class="text-center">
                      <div class="dropdown">
                        <button class="btn btn-primary" type="button" id="accion" data-bs-toggle="dropdown" aria-expanded="false">
                          <i class="bi bi-three-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="accion">
                          <li *ngFor="let o of r.ocupaciones; let i = index"><span class="dropdown-item">{{o.ocupacion}}</span></li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> <!-- end card-body  *ngIf="r.ocupaciones.id_ocupacion != null "-->
      </div> <!-- end card -->
    </div> <!-- end col-->
  </div>



</div>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>

<app-documentos *ngIf="isDocumento"
[id_estudiante]="id_estudiante"
[nombre_participante]="nombre_participante"
(vuelve)="volver($event)"
></app-documentos>

